import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-instagram-business-iq-details',
  templateUrl: './help-instagram-business-iq-details.component.html'
})
export class HelpInstagramBusinessIqDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
